import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '@module/form';
import { BaseQuestionSwitchStrategy } from './base.strategy';
/**
 * Strategy: Single Choice → Other Types
 * Rule 4: Single Choice ↔ Multiple Choice preserves answers
 */

export var SingleChoiceSwitchStrategy = /*#__PURE__*/function (_BaseQuestionSwitchSt) {
  _inherits(SingleChoiceSwitchStrategy, _BaseQuestionSwitchSt);

  var _super = _createSuper(SingleChoiceSwitchStrategy);

  function SingleChoiceSwitchStrategy() {
    _classCallCheck(this, SingleChoiceSwitchStrategy);

    return _super.call(this, QuestionType.SingleChoice);
  }

  _createClass(SingleChoiceSwitchStrategy, [{
    key: "canHandle",
    value: function canHandle(toType) {
      return this.fromType === QuestionType.SingleChoice;
    }
  }, {
    key: "execute",
    value: function execute(toType) {
      switch (toType) {
        case QuestionType.MultipleChoice:
          // Rule 4: Single ↔ Multiple preserves answers (radio → checkbox)
          return {
            shouldPreserveAnswers: true,
            shouldPreserveDescription: true,
            shouldResetToDefault: false,
            shouldClearAnswers: false,
            strategyName: 'SingleChoice → MultipleChoice: Preserve answers'
          };

        case QuestionType.Essay:
          // Rule 5: Any → Essay clears answers
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: false,
            shouldClearAnswers: true,
            strategyName: 'SingleChoice → Essay: Clear answers'
          };

        case QuestionType.FillInBlank:
        case QuestionType.Matching:
          // Rule 6 & 7: Any → Fill/Matching clears and inits default
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: true,
            shouldClearAnswers: true,
            strategyName: "SingleChoice \u2192 ".concat(toType, ": Reset to complex type")
          };

        default:
          return this.getDefaultResult(toType);
      }
    }
  }, {
    key: "getDefaultResult",
    value: function getDefaultResult(toType) {
      return {
        shouldPreserveAnswers: false,
        shouldPreserveDescription: true,
        shouldResetToDefault: true,
        shouldClearAnswers: false,
        strategyName: "SingleChoice \u2192 ".concat(toType, ": Default behavior")
      };
    }
  }]);

  return SingleChoiceSwitchStrategy;
}(BaseQuestionSwitchStrategy);